import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ErpTemplate from '../../components/ErpTemplate';
import { FinField, FinInput } from '../../components/FinField';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function CadastroParticipanteCategoria({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem('empresa');
    const token = localStorage.getItem('token');
    const history = useHistory();
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);

    const buscar = () => {
        setIsLoading(true);
        if (!id) {
            setIsLoading(false);
            return;
        }
        api({
            method: 'get',
            action: `/participanteCategoria/${id}`,
            token,
        }).then((response) => {
            setDados(response.data.data);
        }).catch(() => { }).finally(() => setIsLoading(false));
    };

    const salvar = () => {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
        const requisicao = id
            ? { method: 'put', action: `/participanteCategoria/${id}`, data: dados }
            : { method: 'post', action: '/participanteCategoria', data: { ...dados, empresa } };

        api({
            ...requisicao,
            token,
        })
            .then(() => {
                toast.success('Dados salvos com sucesso!');
                history.push('/participanteCategoria');
            })
            .catch((error) => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => setIsSubmitting(false));
    };

    useEffect(() => {
        document.querySelector('#nome')?.focus();
        buscar();
        // eslint-disable-next-line
    }, []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Categoria</h1>
                        <p className="fin-pp__subtitle">{dados.nome || 'Nova categoria'}</p>
                    </div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" onClick={salvar} disabled={isSubmitting}>
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </div>

                <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Nome" full>
                                <FinInput
                                    id="nome"
                                    value={dados.nome || ''}
                                    onChange={(e) => setDados({ ...dados, nome: e.target.value })}
                                    placeholder="Nome"
                                />
                            </FinField>
                        </div>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
